// extracted by mini-css-extract-plugin
export default {"container":"AK-z","topReviewHeading":"BK-z","criticalReview":"CK-z","favorableReview":"DK-z","vsSeparator":"EK-z"};